module.exports = __webpack_public_path__ + "img/four1Green.81b3cf7e.jpg";